<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { definePage } from 'unplugin-vue-router/runtime'
import { useAuthStore } from '@/stores/auth.store'
import { useApiError } from '@/composables/useApiError'

definePage({
  meta: { layout: 'blank' },
})

const router = useRouter()
const route = useRoute()
const auth = useAuthStore()
const apiError = useApiError()

const email = ref('')
const password = ref('')
const showPassword = ref(false)
const submitting = ref(false)
const fieldErrors = ref<Record<string, string>>({})

async function onSubmit() {
  if (submitting.value) return
  fieldErrors.value = {}
  if (!email.value || !password.value) {
    fieldErrors.value = {
      ...(email.value ? {} : { email: 'Укажите email' }),
      ...(password.value ? {} : { password: 'Укажите пароль' }),
    }
    return
  }
  submitting.value = true
  try {
    await auth.login({ email: email.value, password: password.value })
    const redirect = (route.query.redirect as string | undefined) || '/'
    router.push(redirect)
  } catch (err) {
    const { fieldErrors: fe } = apiError.show(err, 'Неверный email или пароль')
    fieldErrors.value = fe
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <div class="login-page">
    <v-card class="login-card pa-6 pa-sm-8" elevation="8" max-width="420" width="100%">
      <div class="d-flex align-center mb-6" style="gap:12px">
        <div
          class="d-flex align-center justify-center"
          style="width:44px;height:44px;background:#e11d48;border-radius:12px;font-weight:900;color:white;font-size:18px"
        >
          A
        </div>
        <div>
          <div class="text-h6 font-weight-bold">Admin · Influence</div>
          <div class="text-caption text-medium-emphasis">статуспро.club</div>
        </div>
      </div>

      <v-form @submit.prevent="onSubmit">
        <v-text-field
          v-model="email"
          label="Email"
          type="email"
          autocomplete="username"
          autofocus
          :error-messages="fieldErrors.email"
          prepend-inner-icon="mdi-email-outline"
          class="mb-3"
        />
        <v-text-field
          v-model="password"
          label="Пароль"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="current-password"
          :error-messages="fieldErrors.password"
          prepend-inner-icon="mdi-lock-outline"
          :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPassword = !showPassword"
          class="mb-4"
        />
        <v-btn
          type="submit"
          color="primary"
          block
          size="large"
          :loading="submitting"
        >
          Войти
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background:
    radial-gradient(circle at 20% 30%, rgba(225, 29, 72, 0.15), transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(37, 99, 235, 0.15), transparent 50%),
    #0a0a0a;
}

.login-card {
  background: #141414 !important;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
</style>
